import { createSlotFill } from '@wordpress/components';

const NoteIconSlotFill = createSlotFill( Symbol( 'NoteIconSlotFill' ) );

export default NoteIconSlotFill;
